import React, { useState } from 'react';
import { Grid, Box, TextField, Button, Typography, Alert } from '@mui/material';
import axios from '../axiosInstance';
import { toast } from 'react-toastify';
import { useNavigate, Link } from 'react-router-dom';
import eBrary_Logo from '../assets/eBrary_Logo.png';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();

  const handleSendOTP = async () => {
    try {
      await axios.post('https://backend.scholarkart.in/api/forgot-password', { email });
      setOtpSent(true);
      setMessage('OTP sent to your email');
    } catch (err) {
      setMessage('User not found or error sending OTP');
    }
  };

  // Function to handle password reset
  const handleResetPassword = async () => {
    if (newPassword !== confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }
  
    try {
      await axios.post('https://backend.scholarkart.in/api/reset-password', {
        email, otp, newPassword
      });
      toast.success("Password reset successful! Redirecting to login...");
      setMessage('Password reset successful! You can now log in.');
      setTimeout(() => {
        navigate('/LoginPage');
      }, 3000); // 3 seconds delay
    } catch (err) {
      setMessage('Invalid OTP or expired');
    }
  };

  return (
    <Grid container component="main" sx={{ height: '100vh' }}>
      {/* Left Panel */}
      <Grid item xs={12} md={6} sx={{ p: 6 }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                <Link to="/">
                  <img src={eBrary_Logo} alt="eBrary Logo" style={{ height: 60 }} />
                </Link>
        
                <Typography
                    component="h1"
                    variant="h5"
                    sx={{
                      fontWeight: 'bold',
                      textAlign: 'center',
                      textShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
                    }}
                  >
                    Transformation of eBrary and eLearning experience.
                  </Typography>
                  </Box>

    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 10 }}>
      <Typography variant="h5" mb={2}>Forgot Password</Typography>
      {message && <Alert severity="info">{message}</Alert>}

      <TextField
        label="Email"
        fullWidth
        margin="normal"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      {otpSent ? (
        <>
          <TextField
            label="Enter OTP"
            fullWidth
            margin="normal"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
          />
          <TextField
            label="New Password"
            type="password"
            fullWidth
            margin="normal"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <TextField
            label="Confirm Password"
            type="password"
            fullWidth
            margin="normal"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <Button
            fullWidth
            variant="contained"
            onClick={handleResetPassword}
            sx={{ mt: 2 }}
          >
            Reset Password
          </Button>
        </>
      ) : (
        <Button
          fullWidth
          variant="contained"
          onClick={handleSendOTP}
          sx={{ mt: 2 }}
        >
          Send OTP
        </Button>
      )}
    </Box>
                            <Box textAlign="center" mt={2}>
                              <Typography variant="body2">
                                Already know your credentials?
                                <Button
                                  variant="outlined"
                                  size="small"
                                  onClick={() => navigate('/LoginPage')}
                                  sx={{
                                    ml: 1,
                                    borderColor: 'rgb(11, 2, 114)',
                                    color: 'rgb(11, 2, 114)',
                                    fontWeight: 'bold'
                                  }}
                                >
                                  Sign In
                                </Button>
                              </Typography>
                            </Box>
      </Grid>

      {/* Right Panel */}
      <Grid item xs={false} md={6} sx={{
        background: 'linear-gradient(to right,rgb(11, 2, 114),rgb(7, 67, 197))',
        color: '#fff', display: 'flex', flexDirection: 'column',
        justifyContent: 'center', alignItems: 'center', textAlign: 'center', px: 6,
      }}>
        <Typography variant="h5" fontWeight="bold">
          Your education, your way. Access courses, libraries, and more anytime, anywhere.
        </Typography>

        <br />
        <Typography variant="body1">
          Welcome to eBrary Guru—the ultimate destination for seamless learning and exploration! Access a vast library of over eBooks, eJournals, and research articles. Enroll in your courses, connect with specialized AI chatbots, and keep track of your progress—all in one unified platform. Dive into a world of knowledge where education is personalized, accessible, and empowering. Your journey towards excellence begins here.
        </Typography>
      </Grid>
    </Grid>
  );
};

export default ForgotPasswordPage;
